import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'libero-init-sign-in-modal',
  templateUrl: './init-sign-in-modal.component.html',
  styleUrls: ['./init-sign-in-modal.component.scss'],
  standalone: false
})
export class InitSignInModalComponent {
  @Input() public show: boolean | null = null;
  @Input() public hasPortfolioOrStrategy!: boolean;
  @Input() public maxRiskScore?: number;
  @Input() public hasStrategiesAccess?: boolean;
  @Output() public modalAddMoneyLinkClick = new EventEmitter<void>();
  @Output() public modalAddPortfolioBtnClick = new EventEmitter<void>();
  @Output() public modalAddStrategyBtnClick = new EventEmitter<void>();
  @Output() public modalConsultBtnClick = new EventEmitter<void>();

  public getPortfolioTypesIdxsByMax(maxRiskScore: number | undefined): number[] {
    if (!maxRiskScore) {
      return [];
    }
    return Array.from({length: maxRiskScore}, (_, i) => i + 1);
  }

  public onAddMoneyClick(): void {
    this.modalAddMoneyLinkClick.emit();
  }

  public onAddNewPortfolioClick(): void {
    this.modalAddPortfolioBtnClick.emit();
  }

  public onAddNewStrategyClick(): void {
    this.modalAddStrategyBtnClick.emit();
  }

  public onConsultClick(): void {
    this.modalConsultBtnClick.emit();
  }
}
